import type { Topic } from '@/types';

export const topics: Topic[] = [
  {
    id: 't1',
    title: '盛夏影视季：好剧好片一次看够',
    slug: 'topic-summer-screen',
    cover: 'https://readdy.ai/api/search-image?query=summer%20cinema%20theme%20collage%20with%20warm%20sunset%20light%20and%20film%20reels%2C%20cinematic%20entertainment%20mood%2C%20warm%20amber%20and%20deep%20orange%20tones%2C%20high%20detail&width=900&height=600&seq=topic-01-cover&orientation=landscape',
    desc: '从悬疑黑马到科幻巨制，精选这个夏天最值得走进影院的六部作品。',
    intro: '专题汇聚暑期档最受关注的影视作品，涵盖悬疑、科幻、都市、动画等类型，带你一次get今年的观影清单。',
    articleIds: ['a1', 'a2', 'a3', 'a5', 'a6', 'a4'],
  },
  {
    id: 't2',
    title: '华语新声：值得单曲循环的年度音乐',
    slug: 'topic-new-sound',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20music%20soundwave%20visual%20with%20warm%20stage%20lights%2C%20contemporary%20album%20aesthetic%2C%20amber%20and%20deep%20charcoal%20tones%2C%20high%20detail&width=900&height=600&seq=topic-02-cover&orientation=landscape',
    desc: '新歌、专辑、演唱会，收录今年最值得循环的华语音乐现场与作品。',
    intro: '从流行到说唱，从民谣到电子，这份专题歌单记录了华语乐坛正在发生的新鲜声音。',
    articleIds: ['b1', 'b3', 'b2', 'b5', 'b4', 'b6'],
  },
  {
    id: 't3',
    title: '生活潮流志：这个夏天怎么过才够味',
    slug: 'topic-lifestyle',
    cover: 'https://readdy.ai/api/search-image?query=stylish%20lifestyle%20flatlay%20with%20fashion%20beauty%20and%20coffee%20items%2C%20warm%20minimal%20aesthetic%2C%20cream%20and%20terracotta%20palette%2C%20high%20detail&width=900&height=600&seq=topic-03-cover&orientation=landscape',
    desc: '穿搭、美妆、露营、咖啡……关于年轻人生活方式的一切潮流灵感都在这里。',
    intro: '专题聚焦年轻一代的生活美学，从衣橱到户外，从妆容到咖啡馆，帮你把日子过成想要的样子。',
    articleIds: ['d1', 'd2', 'd4', 'd6', 'd3', 'd5'],
  },
];